"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeStore = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const query_1 = require("@reduxjs/toolkit/query");
const connected_react_router_1 = require("connected-react-router");
const lp_redux_api_1 = require("lp-redux-api");
const redux_1 = require("redux");
const redux_form_1 = require("redux-form");
const redux_modal_1 = require("redux-modal");
const redux_sessions_1 = require("redux-sessions");
const ab_tests_api_1 = require("ab-tests-api");
const config_1 = require("config");
const api_1 = require("../services/api");
const consumerApiSlice_1 = require("../services/api/consumerApiSlice");
const internalPortalApiSlice_1 = require("../services/api/internalPortalApiSlice");
const merchantApiSlice_1 = require("../services/api/merchantApiSlice");
const browserHistory_1 = __importDefault(require("../services/browserHistory"));
const isCookieValidMiddleware_1 = require("./isCookieValidMiddleware");
const reducer_1 = require("./reducer");
const serverErrorLoggingMiddleware_1 = require("./serverErrorLoggingMiddleware");
function initializeStore(initialState = {}) {
    const enhancers = [
        (0, redux_1.applyMiddleware)(api_1.middleware, api_1.apiMiddlewareRTK, serverErrorLoggingMiddleware_1.serverErrorLoggingMiddleware, isCookieValidMiddleware_1.isCookieValidMiddleware, (0, connected_react_router_1.routerMiddleware)(browserHistory_1.default)),
        (0, redux_sessions_1.enhancer)(),
    ];
    const reducer = {
        api: lp_redux_api_1.reducer,
        internalPortalApi: internalPortalApiSlice_1.api.reducer,
        merchantPortalApi: merchantApiSlice_1.api.reducer,
        consumerPortalApi: consumerApiSlice_1.api.reducer,
        abTestsApi: ab_tests_api_1.abTestsApi.reducer,
        form: redux_form_1.reducer,
        modal: redux_modal_1.reducer,
        [reducer_1.reducerKey]: reducer_1.reducer,
        router: (0, connected_react_router_1.connectRouter)(browserHistory_1.default),
        sessions: redux_sessions_1.reducer,
    };
    return (0, toolkit_1.configureStore)({
        reducer,
        middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }).concat(internalPortalApiSlice_1.api.middleware, merchantApiSlice_1.api.middleware, consumerApiSlice_1.api.middleware, ab_tests_api_1.abTestsApi.middleware),
        enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(enhancers),
        devTools: (0, config_1.isNodeEnvProduction)() ? false : true,
        preloadedState: initialState,
    });
}
exports.initializeStore = initializeStore;
//extends global window interface to include store and redux dev tools
// moved to js/types
const store = initializeStore();
(0, query_1.setupListeners)(store.dispatch);
// Add store as global window variable for console debugging
window.store = store;
exports.default = store;
